module.exports = __webpack_public_path__ + "img/38_12.7b4e2b3a.png";